export const SelfSignUpFields = {
    TENANT_TYPE: "tenant_type",

    TENANT_NAME: "tenant_name",
    INDUSTRY_TYPE: "tenant_industryType",
    TENANT_REG_DETAILS: "tenant_regDetails",

    TENANT_ADDRESS1: "tenant_address1",
    TENANT_ADDRESS2: "tenant_address2",
    TENANT_CITY: "tenant_city",
    TENANT_STATE: "tenant_state",
    TENANT_POSTCODE: "tenant_postCode",
    TENANT_COUNTRY: "tenant_country",
    
    CONTACT: "contact",
    TENANT_TITLE: "tenant_title",
    TENANT_FIRSTNAME: "tenant_firstName",
    TENANT_LASTNAME: "tenant_lastName",
    TENANT_DESIGNATION: "tenant_designation",
    TENANT_EMAIL: "tenant_email",
    TENANT_PHONE: "tenant_phone",

    TENANT_SYSTEMCAPABILITIES: "tenant_systemCapabilities",
    TENANT_NUMOFUSERLIC: "tenant_numberOfUserLicenses",

    // TENANT_SUBSCRIPTION_MODEL: "tenant_subscriptionModel",
    // TENANT_PAYMENT_DETAILS: "tenant_paymentDetails",
    TENANT_TERMS_AND_CONDITIONS: "tenant_termAndConditions",
    // Add more as needed
};

export const adminSelfSignup = {
    ADMIN_USER: "admin_user",
    TENANT_ADMIN_LOGIN_ID: "tenant_adminLoginId",
    TENANT_ADMIN_LOGIN_PASSWORD: "tenant_adminLoginPassword",
    TENANT_LANGUAGE: "tenant_language"
}

export const addressRequiredFields = [
    SelfSignUpFields.TENANT_ADDRESS1,
    SelfSignUpFields.TENANT_ADDRESS2,
    SelfSignUpFields.TENANT_CITY,
    SelfSignUpFields.TENANT_STATE,
    SelfSignUpFields.TENANT_POSTCODE,
    SelfSignUpFields.TENANT_COUNTRY
]

export const contactRequiredFields = [
    SelfSignUpFields.TENANT_TITLE,
    SelfSignUpFields.TENANT_FIRSTNAME,
    SelfSignUpFields.TENANT_LASTNAME,
    SelfSignUpFields.TENANT_DESIGNATION,
    SelfSignUpFields.TENANT_EMAIL,
    SelfSignUpFields.TENANT_PHONE,
]


export const partnerAddressRequiredFields = [
    "partner_address1",
    "partner_city",
    "partner_state",
    "partner_postCode",
    "partner_country"
]

export const partnerContactRequiredFields = [
    "partner_title",
    "partner_firstName",
    "partner_lastName",
    "partner_designation",
    "partner_email",
]